/* unplugin-vue-components disabled */import script from "./mg-u-dict-list.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-u-dict-list.vue?vue&type=script&setup=true&lang=js"

import "./mg-u-dict-list.vue?vue&type=style&index=0&id=90e9038c&lang=less&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e9038c"]])

export default __exports__